import i18n from "../i18n";

export const getPeriodOptions = () => [
  { value: 'per_month', label: i18n.t('per maand') },
  { value: 'per_quarter', label: i18n.t('per kwartaal') },
  { value: 'per_half_year', label: i18n.t('per half jaar') },
  { value: 'per_year', label: i18n.t('per jaar') },
  { value: 'at_once', label: i18n.t('ineens') },
];

export const periodOptionInMonths = {
  per_month: 1,
  per_quarter: 3,
  per_half_year: 6,
  per_year: 12,
};

export const tenants = {
  DEFAULT: 'default',
  VAN_BRUGGEN: 'van-bruggen',
};

export const getSigningStatusOptions = () => {
  return {
    open: i18n.t('Openstaand'),
    signed: i18n.t('Ondertekend'),
  };
};